import Image from "next/image";
import React from "react";

const Location = ({ location }) => {
  return (
    <div className="flex items-center gap-1.5">
      <Image
        src="/icons/location.svg"
        alt="location"
        width={18}
        height={18}
        className="object-contain"
      />
      <span className="text-xs font-medium leading-normal text-themeBlack">
        {location}
      </span>
    </div>
  );
};

export default Location;
